import Component from '../abstracts/Component';
import vex from 'vex-js';
import {isTablet} from '../utils/MobileUtils';
import {debounce} from '../utils/ScreenUtils';

export default class PdpMainComponent extends Component {
  constructor(compEl) {
    super(compEl);
    // this.sizeGuideTriggerList = this.$component.querySelectorAll(this.SELECTORS.sizeGuideTrigger);
    this.goto = this.$component.querySelector(this.SELECTORS.goto);
    this.gallery = this.$component.querySelector(this.SELECTORS.gallery);
    this.skuInfo = this.$component.querySelector(this.SELECTORS.skuInfo);
    this.skuInfoContainer = this.$component.querySelector(this.SELECTORS.skuInfoContainer);
    this.init();
  }

  get SELECTORS() {
    return {
      header: '[data-js-component="HeaderComponent"]',
      wrapper: '[data-wrapper]',
      skuInfo: '[data-info-container]',
      skuInfoContainer: '.js-info-container',
      completeLook: '[data-js-component="CompleteLookComponent"]',
      images: '[data-images]',
      image: '[data-image]',
      sizeGuideTrigger: "[data-js-size-guide]",
      goto: "[data-go-to]",
      gallery: ".js-gallery"
    };
  }

  get CLASSES() {
    return {
      HIDDEN: '--hidden'
    }
  }

  init() {
    if (this.goto) {
      const gotoAnchorSelector = this.goto.querySelector("a").getAttribute("href");
      // if there is target element, show link
      if (document.querySelector(gotoAnchorSelector)) {
        this.goto.classList.remove(this.CLASSES.HIDDEN);
      }
    }
  }

  handleGoto() {
    this.$on(this.$customEvents.CAROUSEL.initCarousel, () => {
      if (isTablet()) {
        console.info("--tablet--");
        const gotoYPosition = this.gallery.offsetHeight - 60;
        this.goto.style.top = gotoYPosition + "px";
      }
    });
  }

  // handle size guide open //
  // handleSizeGuide() {
  //   const self = this;
  //   if (this.sizeGuideTriggerList.length > 0) {
  //     this.sizeGuideTriggerList.forEach((sizeGuideTrigger) => {
  //       sizeGuideTrigger.addEventListener("click", (event) => {
  //         event.preventDefault();
  //         sizeGuideTrigger.setAttribute('disabled', '');
  //         fetch(sizeGuideTrigger.href)
  //           .then(response => response.text())
  //           .then(text => {
  //             const parser = new DOMParser();
  //             const doc = parser.parseFromString(text, "text/html");
  //             const sizeGuide = doc.querySelector('[data-ajax-chunk]');
  //             vex.open({
  //               unsafeContent: sizeGuide,
  //               closeClassName: 'icon-close',
  //               className: 'size-guide',
  //               showCloseButton: true,
  //               afterOpen: function () {
  //                 this.closeEl.classList.remove('vex-close');
  //                 self.importComponents("CollapseComponent")
  //                   .then(({default: module}) => {
  //                     const component = new module(sizeGuide);
  //                     component.render();
  //                   })
  //                   .catch(error => {
  //                     console.error("Failed to load the component", error.stack);
  //                   });
  //               },
  //               afterClose: function () {
  //                 sizeGuideTrigger.removeAttribute('disabled');
  //               }
  //             });
  //           })
  //           .catch(error => console.error(error));
  //       });
  //     });
  //   }
  // }

  // importComponents(componentName) {
  //   return import(`../components/${componentName}`);
  // }

  bindEvents() {
    // this.handleSizeGuide();
    this.handleGoto();

    window.addEventListener("resize", debounce((e) => {
      console.info("--resize completed--");
      this.$emit(this.$customEvents.SCREEN_EVENTS.resize);
    }, 300))
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
